import axios from "axios";
import funplus from "../../router/funplus";
import country_list from "../../locales/country_list.json";
const host = window.location.host;
const parts = host.split(".");
const currentDate = new Date();
const lang = window.navigator.userLanguage || window.navigator.language;
const language = lang.substring( 0, 2 ); 
let brwlang = localStorage.getItem("lang_fplus");

if(language =='ms'){
  brwlang ='malay';
}else if(language =='ar'){
  brwlang ='arabic';
}else if(language =='el' || parts[0] =='gr'){
  brwlang ='greek';
}else if(language =='bg' || parts[0] =='bg'){
  brwlang ='bulgarian';
}else if(language =='no' || parts[0] =='no'){
  brwlang ='norwegian';
}else if(language =='id'){
  brwlang ='indonesian';
}else if(language =='th'){
  brwlang ='thai';
}else if(language =='cs' || parts[0] =='cz'){
  brwlang ='czech';
}else if(language =='en'){
  brwlang ='english';
}
//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

let res = Number(parts[1]);
let type = Number.isInteger(res);
let gcid = "";

if (type == true) {
  gcid = parts[1];
} else {
  gcid = "";
}

const state = {
  live: `http://cook.grabmobi.com`,
  local: `http://[::1]/PuretechGlobalContentPortal`,
  proxyurl: `http://api.allorigins.win/get?url=`,
  //allsubcategory
  allsubcategory_fplus: {},
  //auth
  auth_fplus: "",
  //hotpicks.vue
  pageHP_fplus: {},
  //popular.vue
  pagePop_fplus: {},
  //notification.vue
  notification_fplus: {},
  //icon
  hotpickIcon_fplus: require(`../../assets/funplus/imgs/other/Hot Picks.svg`),
  popularIcon_fplus: require(`../../assets/funplus/imgs/other/Populars.svg`),
  langButton_fplus: ``,
  country_fplus: parts[0],
  host_fplus: host,
  lang_fplus: localStorage.getItem("lang_fplus"),
  // lang_fplus: brwlang,
  type: "browse",
  gcid_fplus: gcid,
  hpisLoad_fplus: false,
  renew_date_fplus: '',
  subscription_date_fplus: '',
  msisdn_fplus: '',
  country_name_fplus: '',
  gateway_fplus: '',
  is_unsub: '0',
};

const getters = {
  langButton_fplus: state => state.langButton_fplus,
  lang_fplus: state => state.lang_fplus,
  gcid_fplus: state => state.gcid_fplus,
  host_fplus: state => state.host_fplus,
  country_fplus: state => state.country_fplus,
  allSubcategory_fplus: state => state.allsubcategory_fplus,
  allHotPicksCategory_fplus: state => state.hotpicksCategory_fplus,
  allHotPicksData_fplus: state => state.hotpicksData_fplus,
  pageHotPicks_fplus: state => state.pageHP_fplus,
  pagePopular_fplus: state => state.pagePop_fplus,
  HotPickIcon_fplus: state => state.hotpickIcon_fplus,
  PopularIcon_fplus: state => state.popularIcon_fplus,
  notification_fplus: state => state.notification_fplus,
  auth_fplus: state => state.auth_fplus,
  hpisLoad_fplus: state => state.hpisLoad_fplus,
  renew_date_fplus: state => state.renew_date_fplus,
  subscription_date_fplus: state => state.subscription_date_fplus,
  msisdn_fplus: state => state.msisdn_fplus,
  country_name_fplus: state => state.country_name_fplus,
  gateway_fplus: state => state.gateway_fplus,
  is_unsub_fplus: state => state.is_unsub
};

const actions = {
  async fetchLocale_fplus({ commit }, lang) {
    for (let [key, value] of Object.entries(country_list)) {
      if(lang == value.language){
        lang = value.language
      }else{
        //english
        lang = lang
      }
    }
    
    commit("setLanguage", lang);
  },
  async fetchTranslateButton_fplus({ commit }, country) {
    for (let [key, value] of Object.entries(country_list)) {
      if(country == key){
        let button = `<button id="lang2" lang="${value.language}" class="mobiBtn sm">
        <img lang="${value.language}" src="${value.flag_rec}" />
        <span lang="${value.language}">${value.button_text}</span>
        </button>`

        commit("setButton", button);
      }
    }
  },
  async fetchAllSubcategory_fplus({ commit }, subcategory) {
    //to get the subcategory translation
    let subcateg = await axios.get(
      `${state.live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=${subcategory}&limit=1&offset=0&domain=${host}`
    );

    commit("setAllSubcategory", subcateg.data.data);
  },
  async fetchPageHotPicks_fplus({ commit }, file) {
    let data = file[0];

    let limit = 0;

    if (file[1] != undefined) {
      limit = parseInt(
        file[1].target.options[file[1].target.options.selectedIndex].value
      );
    } else {
      //default
      limit = 200;
    }

    let response = [];

    if (data == undefined) {
      response = await axios.get(
        `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=${limit}&offset=0&domain=${host}`
      );
    } else {
      response = await axios.get(
        `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=${data}&limit=${limit}&offset=0&domain=${host}`
      );
    }

    response.data.data.sort((a, b) =>
      a.cont_name_english.localeCompare(b.cont_name_english)
    );

    // console.log(response.data.data);

    commit("setPageHotPicks", response.data.data);
  },
  async fetchPagePopular_fplus({ commit }, e) {
    let limit = 0;

    if (e != undefined) {
      limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
    } else {
      //default
      limit = 200;
    }

    let response = await axios.get(
      `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=${limit}&offset=0&domain=${host}`
    );

    response.data.data.sort(
      (a, b) =>
        // a.content_name.localeCompare(b.content_name),
        b.rating - a.rating
    );

    commit("setPagePopular", response.data.data);
  },
  async fetchToken_fplus({ commit, dispatch }, id) {
    let auth = "";
    let check = "";

    let token = localStorage.getItem("userToken_fplus");
    let userProfile = localStorage.getItem("userProfile_fplus");

    let str = window.location.pathname;
    let path = str.split("/");
    path.pop();
    path = path.join('/');

    if(path == ''){
      path = '/home';
    }

    if (token != null) {
      //checking if have token
      auth = token;
    } else {
      //checking if have param id
      auth = id;
    }

    if (auth != undefined) {
      //to check if token has numbers and letters
      // check = dispatch("checkToken_fplus", auth);
      auth = auth.toLowerCase();
      var letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';
      if (auth.match(letterNumber)) {
        check = true
      } else {
        check = false
      }
    } else {
      funplus.push({ name: "Login" }).catch(err => {});
    }

    if (check == true) {
      //if check is true
      let data = {
        code: auth,
        verbose: "1"
      };
     
      if (token != null) {
        if(data.code == 'fplus80'){
          localStorage.setItem("userToken_fplus", data.code);
          commit("setAuth", "guest");
        }else{
          localStorage.setItem("userToken_fplus", data.code);
          commit("setUserProfile", JSON.parse(userProfile));
          commit("setAuth", "loggedin");
        }
        // EventBus.$emit("logged-in", "loggedin");
      } else {
        if(data.code == 'fplus80'){
          localStorage.setItem("userToken_fplus", data.code);
          commit("setAuth", "guest");
          funplus.push({ path: path }).catch(err => {});
        } else{ 
         
          let responses = await axios.post(
            `${state.proxyurl}`+ encodeURIComponent(`http://gateway.puretechglobal.net/gateway_request/api/sub/?code=${data.code}&verbose=${data.verbose}`)
          );
          
          var response = JSON.parse(responses.data.contents);
         
          if (response.status == "active") {
            localStorage.setItem("userToken_fplus", data.code);
            localStorage.setItem("userProfile_fplus", responses.data.contents)
            commit("setUserProfile", response);
            commit("setAuth", "loggedin");
            funplus.push({ path: path }).catch(err => {});
            
          } else if (response.status == "inactive") {
            if (data.code != undefined) {
              alert(response.status.toUpperCase());
            }
            funplus.push({ name: "Login" }).catch(err => {});
          }
        }
      }
    } else {
      //if check is false
      funplus.push({ name: "Login" }).catch(err => {});
    }
  },
  async getDomain_fplus({ commit }, host){
    let response = await axios.get(`${state.live}/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6`);

    let dom= response.data.data; 
    dom = dom.filter(item =>{
      
      return item.domain == host;
    })
    
    let domain = ""
    
    if(dom != ""){ 
      domain = dom[0].is_unsub;
      
      if(dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id)
    }else{ 
      domain = '0'
    }
    commit("setUnsubButton", domain);
  },
  async checkToken_fplus({ commit }, auth) {
    var letterNumber = /^[0-9a-zA-Z]+$/;
    if (auth.match(letterNumber)) {
      return true;
    } else {
      return false;
    }
  },
  async subContent_fplus({ commit }, file) {
    let token = localStorage.getItem("userToken_fplus");
    let lang = localStorage.getItem("lang_fplus");
    let alert_pop = "";
    let alert_lang = require(`../../locales/funplus/${lang}.json`);
    alert_pop = alert_lang.not_subs;

    if(state.auth_fplus == 'guest'){
      commit("setAuth", "");
      localStorage.removeItem("userToken_fplus");
      funplus.push({ name: "Login" }).catch(err => {});
    }else{ 
      if (token != null) {
        if (file[1] != "application/x-zip-compressed") {
          axios.post(`${state.live}/api/newcontents_statistic`, {
            token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
            country: state.country_fplus,
            product: 'funplus',
            content_id: file[2],
            type: "download"
          })
          window.location.href = file[0];
          // window.open(file[0], "_blank");
        } else {
          axios.post(`${state.live}/api/newcontents_statistic`, {
            token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
            country: state.country_fplus,
            product: 'funplus',
            content_id: file[2],
            type: "play"
          })

          window.open(file[0], "_blank");
        }
      } else {
        alert(alert_pop);
        setTimeout(() => {
          funplus.push({ name: "Login" }).catch(err => {});
        }, 1000);
      }
    }
  },
  async login_fplus({ commit }, loginAuth) {
    commit("setAuth", loginAuth);
  },
  async fetchNotification_fplus({ commit }) {
    let notify = [];
    let date = currentDate.getUTCDate();
    let w = week % 2;

    if (w != 0) {
      date = date + 10;
    }

    let res = await axios.get(
      `${state.live}/api/contents/newcontents_notification?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&domain=${host}`
    );

    let data = res.data.data;
    let noti = data.map(noti => {
      noti.titleSub_english = noti.subcategory;
      if (noti.subcategory_translate != null) {
        let sub_trans = JSON.parse(noti.subcategory_translate);
        if (sub_trans != null) {
          let trans_len = Object.keys(sub_trans).length;
          let trans_arr = Object.keys(sub_trans);

          if (sub_trans != null || sub_icon != null) {
            for (let i = 0; i < trans_len; i++) {
              noti["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
            }
          }
        }
      }
      return noti;
    });

    // if(w == 0){
    //   //name ascending
    //   noti.sort((a, b) => a.content_name.localeCompare(b.content_name))
    // }else{
    //   //name descending
    //   noti.sort((a, b) => b.content_name.localeCompare(a.content_name))
    // }

    // notify = noti.slice(0,5);

    commit("setNotification", noti);
  },
  async logout_fplus({commit}, is_unsub){
    $("#exampleModalCenter").modal("hide"); 
    if(is_unsub != '0'){
      let token = localStorage.getItem("userToken_fplus")
      let responses = await axios.post(`${state.proxyurl}`+ encodeURIComponent(`http://api.puretechglobal.net/gateway_request/${state.country_name_fplus}/${state.gateway_fplus}/unsub.php?code=${token}&msisdn=${state.msisdn_fplus}`));
      removeStorage()
      var response = JSON.parse(responses.data.contents); 
      if(responses.data.contents == 'success' || response.status =='success'){ 
        if (state.gcid_fplus =='208'||state.gcid_fplus =='225' || state.gcid_fplus =='226' || state.gcid_fplus =='278') {
          funplus.push({ name: 'Unsubscription'}).catch(err => {});
        } else {
          funplus.push({ name: 'Login'}).catch(err => {});
         
        }
      }else{
        setTimeout(() => {
          location.reload();
        }, 0);
      }
      
    }else{
      removeStorage();
    }

    function removeStorage(){
      localStorage.removeItem("userProfile_fplus");
      localStorage.removeItem("userToken_fplus");
      localStorage.removeItem("logged-in");
    } 
    
  }
};

const mutations = {
  setPageHotPicks: (state, response) => (state.pageHP_fplus = response),
  setPagePopular: (state, response) => (state.pagePop_fplus = response),
  setNotification: (state, response) => (state.notification_fplus = response),
  setAuth: (state, response) => (state.auth_fplus = response),
  setButton: (state, response) => (state.langButton_fplus = response),
  setLanguage: (state, response) => (state.lang_fplus = response),
  setAllSubcategory: (state, response) => (state.allsubcategory_fplus = response),
  setUserProfile: (state, response) => (
    state.renew_date_fplus = response.next_renew_date,
    state.subscription_date_fplus = response.subscription_date,
    state.msisdn_fplus = response.msisdn,
    state.country_name_fplus = response.country_code,
    state.gateway_fplus = response.gateway_code
  ),
  setGatewayID: (state, response) =>(
    state.gcid_fplus = response
  ),
  setUnsubButton: (state, response) => (
    state.is_unsub = response
  )
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/funplus-store.js